









































import { Component, Vue } from 'vue-property-decorator'
import { currentUserIs, User, UserRole } from '@/types/Users'
import EditUserDialog from './EditUserDialog.vue'
import Roles from '@/components/Roles.vue'
import { loadWorkforce } from '@/services/users'

@Component({
  metaInfo: {
    title: 'Users',
  },
  components: {
    EditUserDialog,
    Roles,
  },
})
export default class Users extends Vue {
  loading = false
  editUserDialog = false
  headers = [
    {
      text: 'Name',
      value: 'name',
    },
    {
      text: 'Email',
      value: 'email',
    },
    {
      text: 'Phone',
      value: 'phone',
    },
    {
      text: 'Manager',
      value: 'manager_id',
    },
    {
      text: 'Roles',
      value: 'roles',
      align: 'end',
    },
  ]

  async mounted() {
    this.loading = true
    try {
      await loadWorkforce(this.$store)
    } finally {
      this.loading = false
    }
  }

  get workforce() {
    return this.$store.getters.workforce
  }

  get userIsOrgManager() {
    return currentUserIs(UserRole.Admin)
  }

  user(userId: number) {
    return this.$store.getters.user(userId)
  }

  openUser(user: User) {
    this.$router.push({
      name: 'user',
      params: {
        userId: user.id.toString()
      }
    })
  }
}
